import React from 'react';
import classnames from 'classnames'
import ModalInner from '../layoutItems/modalInner';
import { withLocalize, Translate } from 'react-localize-redux';
import { Formik, Form, Field } from "formik";
import { selectDefaultStyles } from '../styling/selectDefaultStyles';
import BbDatePicker from "../common/datePicker";
import BbFormikCheckbox from "../styling/bbFormikCheckbox";
import { BbSelectNoFormik } from '../styling/bbInput';
import { validateInput } from '../../store/storeFunctions';

class CustomRelationPopup extends React.Component {

    defaultValues = {
        ...this.props.data,
        newNote: ''
    }

    currencyOptions =
        [{ label: ' ', value: '' },
        { label: 'CZK', value: 'CZK' },
        { label: 'EUR', value: 'EUR' }];

    constructor(props) {
        super(props);
        this.state = {
            errors: {}
        };
    }

    formValid(values) {
        if (document.getElementById('addRelStartDate').value === '') {
            this.setState({
                errors: { StartDate: this.props.translate('Common.RequiredField') }
            });
            return false;
        }
        else if (document.getElementById('addRelStartDate').className.indexOf('is-danger') !== -1) {
            this.setState({
                errors: { StartDate: this.props.translate('Charts.InvalidDate') }
            });
            return false;
        }
        if (document.getElementById('addRelEndDate').value !== '' && document.getElementById('addRelEndDate').className.indexOf('is-danger') !== -1) {
            this.setState({
                errors: { EndDate: this.props.translate('Charts.InvalidDate') }
            });
            return false;
        }
        return true;
    }

    render() {
        return (
            <ModalInner title={this.props.relationPopupType === 'edit' ? this.props.translate('Charts.EditRelation') : this.props.translate('Charts.AddRelation')} close={this.props.close}>
                <Formik
                    initialValues={this.defaultValues}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, values }) => (
                        <Form className="custom-popup-form">
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationType' /></div>
                                <div className="col-md-8"><Field className="input" type="text" name="RelationShortening" style={{ width: '100%' }} maxLength="10" disabled={!values.CurrentUser && this.defaultValues.RelationShortening !== ''} onInput={(e) => validateInput(e)} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationFromSubject' /></div>
                                <div className="col-md-8">
                                    <BbSelectNoFormik style={{ width: '100%' }} styles={selectDefaultStyles} name="SubjectFrom"
                                        options={values.subjectOptions} value={values.subjectOptions.filter(option => option.value === values.SubjectFrom)}
                                        onChange={(e) => { setFieldValue('SubjectFrom', e.value); setFieldValue('SubjectTo', values.subjectOptions.filter(option => option.value !== e.value)[0].value) }} isDisabled={!values.CurrentUser}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationToSubject' /></div>
                                <div className="col-md-8">
                                    <BbSelectNoFormik style={{ width: '100%' }} styles={selectDefaultStyles} name="SubjectTo"
                                        options={values.subjectOptions} value={values.subjectOptions.filter(option => option.value === values.SubjectTo)}
                                        onChange={(e) => { setFieldValue('SubjectTo', e.value); setFieldValue('SubjectFrom', values.subjectOptions.filter(option => option.value !== e.value)[0].value) }} isDisabled={!values.CurrentUser}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationFromTo' /></div>
                                <div className="col-md-4">
                                    <BbDatePicker
                                        afterDateChange={(d) => setFieldValue('StartDate', d)}
                                        value={values.StartDate}
                                        style={{ width: '100%' }}
                                        name="StartDate"
                                        id="addRelStartDate"
                                        yearsBack={120}
                                        disabled={!values.CurrentUser && this.defaultValues.StartDate !== null}
                                        formDateFormat="DD.MM.YYYY" />
                                    {this.state.errors.StartDate && <div style={{ color: 'red' }}>{this.state.errors.StartDate}</div>}
                                </div>
                                <div className="col-md-4">
                                    <BbDatePicker
                                        afterDateChange={(d) => setFieldValue('EndDate', d)}
                                        value={values.EndDate}
                                        style={{ width: '100%' }}
                                        name="EndDate"
                                        id="addRelEndDate"
                                        yearsBack={120}
                                        disabled={!values.CurrentUser && this.defaultValues.EndDate !== null}
                                        hasRightBorder={true}
                                        formDateFormat="DD.MM.YYYY" />
                                    {this.state.errors.EndDate && <div style={{ color: 'red' }}>{this.state.errors.EndDate}</div>}
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationSharePct' /></div>
                                <div className="col-md-8"><Field className="input" type="number" name="SharePct" style={{ width: '100%' }} min="0" max="100" disabled={!values.CurrentUser && this.defaultValues.SharePct !== null} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationAmount' /></div>
                                <div className="col-md-5"><Field className="input" type="number" name="Deposit" style={{ width: '100%' }} min="0" max="999999999999999" disabled={!values.CurrentUser && this.defaultValues.Deposit !== null} /></div>
                                <div className="col-md-3">
                                    <BbSelectNoFormik style={{ width: '100%' }} styles={selectDefaultStyles} name="Currency"
                                        options={this.currencyOptions} value={this.currencyOptions.filter(option => option.value === values.Currency)}
                                        onChange={(e) => { setFieldValue('Currency', e.value); }} isDisabled={!values.CurrentUser && this.defaultValues.Currency !== ''}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddRelationSource' /></div>
                                <div className="col-md-8"><Field className="input" type="text" name="RelationSource" style={{ width: '100%' }} maxLength="100" disabled={!values.CurrentUser && this.defaultValues.RelationSource !== ''} onInput={(e) => validateInput(e)} /></div>
                            </div>
                            {values.data.Notes.map((n, i) => (
                                <div className="row" style={{ paddingTop: '5px' }} key={i}>
                                    <div className="col-md-4"><Translate id='Charts.AddEntityNote' /></div>
                                    <div className="col-md-8"><Field className="input" type="text" style={{ width: '100%' }} maxLength="1024" name={`data.Notes[${i}].Note`} disabled={n.UserId !== values.CurrentUserId} onInput={(e) => validateInput(e)} /></div>
                                </div>
                            ))}
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.AddNewEntityNote' /></div>
                                <div className="col-md-8"><Field className="input" type="text" name="newNote" style={{ width: '100%' }} maxLength="1024" onInput={(e) => validateInput(e)} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-4"><Translate id='Charts.BidirecionalRelation' /></div>
                                <div className="col-md-8"><BbFormikCheckbox name={`data.BidirectionalRelation`} id={`BidirectionalRelation`} style={{ minHeight: 'unset' }} /></div>
                            </div>
                            <div className="row" style={{ paddingTop: '15px' }}>
                                <div className="col-md-6"><b><Translate id='Charts.ShareToGroups' /></b></div>
                                <div className="col-md-6"><b><Translate id='Charts.ShareToUsers' /></b></div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <div className="col-md-6 custom-popup-chkgrp">
                                    {values.data.Groups.map((gr, i) => (
                                        <div key={i}>
                                            <BbFormikCheckbox label={gr.name} name={`data.Groups[${i}].checked`} id={`gr_${i}`} style={{ minHeight: 'unset' }} disabled={!values.CurrentUser} />
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-6 custom-popup-chkgrp">
                                    {values.data.Users.map((u, i) => (
                                        <div key={i}>
                                            <BbFormikCheckbox label={u.name} name={`data.Users[${i}].checked`} id={`u_${i}`} style={{ minHeight: 'unset' }} disabled={!values.CurrentUser} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="modal-inner-buttons" style={{ paddingTop: "1em" }}>
                                {this.props.relationPopupType === 'edit' && this.defaultValues.CurrentUser && <button type="button" onClick={() => { this.props.deleteCustomRelation(values.RelationID); this.props.close() }} className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.DeleteRelation" /></button>}
                                {this.props.relationPopupType === 'add' && <button type="button" onClick={() => { if (this.formValid(values)) { this.props.addCustomRelation(values, this.props.translate('Charts.CustomLinks')); this.props.close() } }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.AddBtn" /></button>}
                                {this.props.relationPopupType === 'edit' && <button type="button" onClick={() => { if (this.formValid(values)) { this.props.editCustomRelation(values, this.props.translate('Charts.CustomLinks')); this.props.close() } }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.Save" /></button>}
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        )
    }
}

export default withLocalize(CustomRelationPopup);
